import clsx from "clsx";
import React, { useEffect, useRef, useState } from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import environment from "web/script/modules/environment";
import { getHtmlProps } from "web/script/modules/html-tag-props";
import userProfiler from "web/script/modules/userprofiler";
import styles from "./omnibus-directive-banner.module.css";

function OmnibusDirectiveBannerCopy(): JSX.Element {
    const ref = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        const spanRef = ref.current;

        const handleClick = (e): void => {
            // only track clicks on the anchor tag
            if (spanRef && spanRef.contains(e.target) && e.target.tagName === "A") {
                analytics.event("omnibus_banner", "cta_click");
            }
        };

        if (spanRef) {
            spanRef.addEventListener("click", handleClick);
        }

        return () => {
            if (spanRef) {
                spanRef.removeEventListener("click", handleClick);
            }
        };
    }, []);

    const omnibusLinkProps = getHtmlProps({
        href: environment.get("urlPatterns.helpProductRanking"),
        target: "_blank",
        rel: "noreferrer noopener",
        class: styles.copyAnchor,
    });

    return (
        <span
            ref={ref}
            className={styles.copy}
            dangerouslySetInnerHTML={{
                __html: gettext("feed.omnibus_disclaimer.label", {
                    omnibus_link_props: omnibusLinkProps,
                }),
            }}
        />
    );
}

export function OmnibusDirectiveBanner(): JSX.Element | null {
    const [isClosed, setIsClosed] = useState(true);

    function handleClick(): void {
        analytics.event("omnibus_banner", "close");
        userProfiler.setOmnibusIsClosed(true);
        setIsClosed(!isClosed);
    }

    useEffect(() => {
        setIsClosed(userProfiler.hasOmnibusBeenClosed());
    }, []);

    if (isClosed) {
        return null;
    }

    return (
        <div className={styles.container}>
            <SVGIcon name={"info-icon"} className={styles.icons}></SVGIcon>
            <OmnibusDirectiveBannerCopy />
            <button onClick={handleClick} className={clsx(styles.icons, styles.closeIcon)}>
                <SVGIcon name={"close"}></SVGIcon>
            </button>
        </div>
    );
}
